<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout>
      <h1>Информация об аттестуемом {{ this.student.uin }}</h1>
      <v-spacer/>
      <v-btn class="mr-0" color="primary" @click="toPdf">Печать</v-btn>
    </v-layout>
    <h2>Результат:
      <span class="red--text" v-if="total<85">Не сдал</span>
      <span class="green--text" v-else>Сдал</span>
    </h2>
    <DataTable :headers="resultHeaders" :items="results">
      <tr slot-scope="props">
        <td class="text-xs-center">{{ props.item.stage}}</td>
        <td class="text-xs-center">{{ props.item.ball }}</td>
        <td class="text-xs-center">{{ props.item.maxBall }}</td>
      </tr>
    </DataTable>
    <h2>Тестирование</h2>
    <DataTable :items="this.student.testStudentAnswers"
               :headers="headers">
      <tr slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td>{{ props.item.questionText }}</td>
        <td>{{ props.item.answerText }}</td>
        <td class="text-xs-center">{{ props.item.ball }}</td>
      </tr>
    </DataTable>
    <h2>Тематические вопросы</h2>
    <DataTable :items="this.student.thematicStudentAnswers"
               :headers="headers">
      <tr slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td v-html="props.item.questionText"></td>
        <td v-html="props.item.answerText"></td>
        <td class="text-xs-center">{{ props.item.ball }}</td>
      </tr>
    </DataTable>
    <h2>Практические задачи</h2>
    <DataTable :items="this.student.practiceStudentAnswers"
               :headers="headers">
      <tr slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td v-html="props.item.questionText"></td>
        <td v-html="props.item.answerText"></td>
        <td class="text-xs-center">{{ props.item.ball }}</td>
      </tr>
    </DataTable>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import StudentService from '@/services/StudentService'
import DataTable from '@/components/fragments/DataTable'
import AttestationService from '@/services/AttestationService'

export default {
  components: {DataTable},
  props: {
    id: String
  },
  data: () => ({
    student: StudentService.getDefaultItem(),
    headers: [
      {text: '№', align: 'center', sortable: false, width: 30},
      {text: 'Текст вопроса', align: 'center', sortable: false},
      {text: 'Текст ответа', align: 'center', sortable: false},
      {text: 'Балл', align: 'center', sortable: false, width: 30}
    ],
    resultHeaders: [
      {text: 'Этап', align: 'center', sortable: false},
      {text: 'Количесво баллов', align: 'center', sortable: false},
      {text: 'Максимальное количество баллов', align: 'center', sortable: false}
    ],
    studentService: undefined,
    attestationService: undefined
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle('Аттестумый ' + this.student.uin)
    },
    resultsTestBall () {
      let balls = 0
      this.student.testStudentAnswers.forEach(item => {
        balls += item.ball
      })
      return balls
    },
    resultsThematicBall () {
      let balls = 0
      this.student.thematicStudentAnswers.forEach(item => {
        balls += item.ball
      })
      return balls
    },
    resultsPracticeBall () {
      let balls = 0
      this.student.practiceStudentAnswers.forEach(item => {
        balls += item.ball
      })
      return balls
    },
    total () {
      return this.resultsTestBall + this.resultsThematicBall + this.resultsPracticeBall
    },
    results () {
      return [
        {stage: 'Тестирование', ball: this.resultsTestBall, maxBall: 50},
        {stage: 'Темтаический', ball: this.resultsThematicBall, maxBall: 30},
        {stage: 'Практический', ball: this.resultsPracticeBall, maxBall: 40},
        {stage: 'Итого', ball: this.total, maxBall: 50 + 30 + 40}
      ]
    }
  },
  created () {
    this.studentService = new StudentService(this.$store)
    this.attestationService = new AttestationService(this.$store)
    this.studentService.getItem(this.id, (data) => {
      this.student = data
    })
  },
  methods: {
    toPdf () {
      this.attestationService.resultToPdf(this.id, blob => {
        this.fileUrl = URL.createObjectURL(blob)
        window.open(process.env.SITE_URL + '/pdf/view?link=' + this.fileUrl)
        window.focus()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.results {
  border: 1px solid #8E8E8E;
  width: 100%;
  text-align: center;
  border-spacing: 0;

  th, td {
    border: 1px solid #8E8E8E;
    padding: 5px 10px;
  }
}

.results__count, .results__max {
  width: 33.33%;
}

</style>

<style lang="scss">
@media print {
  body {
    zoom: 50%; /*or whatever percentage you need, play around with this number*/
  }

  nav {
    display: none;
  }

  /* принт */
  .container {
    padding: 0;
  }

  .data-table {
    box-shadow: none !important;

    /deep/ .v-table {
      background: none;
    }
  }

  .v-card {
    background: none;
    box-shadow: none;
  }

  .v-card__text {
    padding: 0;
  }

  .btn--print {
    display: none;
  }

  th, td {
    padding: 0 5px !important;
  }

  table.v-table thead tr {
    height: auto;
  }
}

.embed {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/student/View.vue